/* unplugin-vue-components disabled */import script from "./HotelPrice.vue?vue&type=script&setup=true&lang=jsx"
export * from "./HotelPrice.vue?vue&type=script&setup=true&lang=jsx"

import "./HotelPrice.vue?vue&type=style&index=0&id=2e11ff52&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e11ff52"]])

export default __exports__